<script setup lang="ts">

const route = useRoute()
const router = useRouter()
const {extraWide} = storeToRefs(useCustomizerStore())

interface MenuItem {
  title: string,
  to: string,
  icon: any,
  disabled?: boolean,
  exact?: boolean,
}

const props = defineProps<{
  items: MenuItem[],
  title?: string
}>()

const determinedRoute = ref(route.path)
const activeRoute = ref(route.path)
watch(activeRoute, (value) => {
  // The v-tabs elements set this value. We watch it, and if it's not what we want, we change it back
  // UI framework... sigh
  activeRoute.value = determinedRoute.value
})

watchEffect(() => {
  const route = router.currentRoute.value;

  determinedRoute.value = props.items.find(item => {
    return route.path.startsWith(item.to);
  })?.to ?? route.path;
  activeRoute.value = determinedRoute.value
})
</script>

<template>
  <v-list v-model="activeRoute" density="compact">
    <v-list-subheader v-if="title">
      <slot>
        <v-divider v-if="extraWide"></v-divider>
        <div v-else>{{title}}</div>

      </slot>
    </v-list-subheader>
    <v-list-item :to="item.to" v-for="(item, i) in items" color="primary">
      <template v-slot:prepend>
        <component
            :is="item.icon"
            :size="24"
        ></component>
      </template>
      <div class="ml-4 text-no-wrap">{{item.title}}</div>
    </v-list-item>
  </v-list>
</template>
